module.exports = __webpack_public_path__ + "img/new_cctv.9062f0e0.jpg";